import React from "react"
import Head from "next/head"
import DOMPurify from "isomorphic-dompurify"

const NextHead = ({
  title = "",
  description = "",
  templateName = "",
  fullUrl = "",
  psKey = "",
  psCountry = "",
  psLanguage = "",
  pageUrl = "",
  metaLanguage = "",
  pdpData: {
    ProductBrandName_s: productName = "",
    productName_s: partsName = "",
    ProductDescriptionProductShort_s: productDescription = "",
    "Color.SKU.Details_ss": skuDetails = [],
  } = {},
  initialImageFullUrl = "",
  isPart = false,
  skuId = "",
  siteName = "",
}) => {
  const selectedSkuDetails =
    skuDetails?.find(item => item.includes(skuId)) ?? ""
  const selectSkuList = selectedSkuDetails?.split("|") ?? []
  const selectedSku = selectSkuList[selectSkuList.length - 1] ?? ""

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": fullUrl,
    additionalType: isPart ? "Service Part" : "",
    name: isPart ? partsName : productName,
    image: initialImageFullUrl,
    description: productDescription,
    sku: selectedSku,
    brand: {
      "@type": "Brand",
      name: siteName,
    },
  }

  return (
    <Head>
      {title && (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </>
      )}
      <meta name="keywords" content="Kohler US Plumbing Bathroom Kitchen" />
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      )}
      {pageUrl ? <meta property="og:url" content={pageUrl} /> : null}
      {templateName ? <meta property="og:type" content={templateName} /> : null}
      {metaLanguage ? (
        <meta
          property="og:locale"
          content={metaLanguage?.toLocaleLowerCase()}
        />
      ) : null}
      {fullUrl ? <link rel="canonical" href={fullUrl} /> : null}
      {psKey ? <meta name="ps-key" content={psKey} /> : null}
      {psCountry ? <meta name="ps-country" content={psCountry} /> : null}
      {psLanguage ? <meta name="ps-language" content={psLanguage} /> : null}
      {/* need to use dangerouslySetInnerHTML in the below block to prevent default encoding */}
      {productName || partsName ? (
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(JSON.stringify(productSchema)),
          }}
        />
      ) : null}
    </Head>
  )
}

export default NextHead
